import React, { useEffect, useState } from "react";
import { CrossIcon, EditIcon } from "../assets/Icons";
import { routes } from "../Api/routes";
import { postRequest } from "../Api";
import { toast } from "react-toastify";
import { useEditUserMutation } from "../store/services/userService";
import ToggleButton from "./ToggleButton";
import { useSelector } from "react-redux";


const EditUserModel = ({ user, openModal, setOpenModal, onSuccessCreate = () => { } }) => {


  const words = useSelector((state) => state.authReducer.words);
  const lang = useSelector((state) => state.authReducer.lang);
  const [editUser, response] = useEditUserMutation();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(user?.name);
  const [number, setNumber] = useState(user?.phone_number);
  const [status, setStatus] = useState(user.status);
  // const [type, setType] = useState('');
  // const [password, setPassword] = useState('');



  const doEditUser = async () => {

    if (!name) return toast.error('Please enter name')
    if (!number) return toast.error('Please enter number')

    const body = {
      name: name,
      phone_number: number,
      id: user.id,
      status: status
      // password: password
    };

    try {
      setLoading(true);
      editUser(body);
      // console.log('here is the result', result);
      // if (result.error) {
      //   setLoading(false);
      //   // console.error(result.error);
      // } else {
      //   toast.success('User added successfully');
      //   setOpenModal(false);
      //   setLoading(false);
      //   // console.log(result.data);
      // }
    } catch (error) {
      setLoading(false);
      console.error('catch', error);
    }



    // setLoading(true);
    // await addUser(body).unwrap();


    // await postRequest(body, routes.addUser, true, onSuccess, onError)

  }

  useEffect(() => {

    if (response.isSuccess) {
      toast.success("User updated Successfully");
      setLoading(false);
      setOpenModal(false)
      // navigate("/dashboard/stores");
    }
    if (response.isError) {
      setLoading(false)
      toast.error("Something wrong try again later!");
    }
  }, [response]);


  return (
    <div dir={lang == 'ar' ? 'rtl' : 'ltr'} className="flex flex-col shadow-md-custom border border-[#D8D8D8] p-4">
      <div className="flex items-center justify-between gap-3">
        <h1 className="text-black text-xl font-medium font-tajawal">{words['Edit user']}</h1>
        <div
          className="flex items-center justify-center h-8 w-8 bg-[#EFEFEF] rounded-full p-1 hover:cursor-pointer"
          onClick={() => setOpenModal(false)}
        >
          <CrossIcon />
        </div>
      </div>
      <div className="flex flex-col gap-5 mt-10">
        <div className="flex flex-col gap-2">
          <label className={`text-black text-sm font-tajawal ${lang == 'ar' ? 'text-right' : 'text-left'} `}>{words['name']}</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            type="text"
            // placeholder="Enter Name"
            className="border border-[#D9D9D9] py-2 px-2 focus:border-themeColor rounded-lg anim font-normal text-sm"
          />
        </div>
        <div className="flex flex-col gap-2">
          <label className={`text-black text-sm font-tajawal ${lang == 'ar' ? 'text-right' : 'text-left'} `}>{words['Phone Number']}</label>
          <input

            onChange={(e) => setNumber(e.target.value)}
            value={number}
            type="number"
            // placeholder="Enter Phone"
            className="border border-[#D9D9D9] py-2 px-2 focus:border-themeColor rounded-lg anim font-normal text-sm"
          />
        </div>

        <div className="flex items-center gap-1.5">
          <div className="text-base font-tajawal">{words['status']}</div>
          <ToggleButton checked={status == 1 ? true : false} setChecked={setStatus} />
        </div>

        {/* <div className="flex flex-col gap-2">
          <label className="text-black text-sm font-normal">Password</label>
          <input
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            placeholder="Enter password"
            className="border border-[#D9D9D9] py-2 px-2 focus:border-themeColor rounded-lg anim font-normal text-sm"
          />
        </div> */}
        {/* <div className="flex flex-col gap-2">
          <label className="text-black text-sm font-normal">User type</label>
          <input
            onChange={(e) => setType(e.target.value)}
            type="text"
            placeholder="Enter User type "
            className="border border-[#D9D9D9] py-2 px-2 focus:border-themeColor rounded-lg anim font-normal text-sm"
          />
        </div> */}
        <div className="flex items-center justify-center">
          <button
            onClick={() => loading ? null : doEditUser()}
            className="button rounded-full !py-2 !px-10 font-tajawal">
            {loading ? <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-white-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
            </svg>
              : words['save']}

          </button>
        </div>
      </div>
    </div>
  );
};

export default EditUserModel;
